import { useEffect, useState } from "react";
import "./CourseCardAll.css";
import fallback_img from "./img/fallback_img.jpg"
import loading_img from "./img/loadingImg.jpg"

import placeholderImg from "../img/thumbnailPlaceholder.png"
import CourseCard1MouseOver from "./CourseCardAllMouseOver";
import { Pencil, Trash2 } from "lucide-react";
import CourseCard1MouseOverNormal from "./CourseCard1MouseOverNormal";
const CourseCardNormal= ({arrCourseCards,setCurrentAppCourses,deleteCourseFallback})=>{
const [hoverCourseCard, setHoverCourseCard] = useState(false);
const [popUpItem, setPopUpItem] = useState({});
         
    const ImageFallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  
     
          const [reloadItems, setReloadItems] = useState(true);
          
             useEffect(()=>{
                 setReloadItems(false); setReloadItems(true);
                 
             },[ ])

               
  return (
    <div style={{ position: "relative",boxShadow:boxShadow,
    overflow: "hidden",aspectRatio: aspectRatio,padding:"0px",border:border, 
     borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
    width:`${width}%`}}  className={``}>
      {!isLoaded && !hasError && (
        <div
         style={
             { 
              borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
      aspectRatio: aspectRatio,
      objectFit: "cover",  }}
       className={``}
        >
          <img
        src={loading_img}
        alt=""
      
       style={
             {
             borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
                position: "absolute",border:border,
      top: 0,
      left: 0,
      width: `${width}%`,padding:"10px",
    
      objectFit: "cover", aspectRatio: aspectRatio,  }}
       className={``}
      />
        </div>
      )}
      
      <img

      
        src={hasError ? fallback_img : src}
        alt=""
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasError(true)}
       style={
             {
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
     
      objectFit: "cover",aspectRatio: aspectRatio  }}
       className={``}
      />
    </div>
  );
};


return(<>
{arrCourseCards?.map((item,index)=>(<>
<div className="courseCard1Outer" 
 onMouseEnter={()=>{
    setTimeout(()=>{setHoverCourseCard(item?.ID)},500);
 }
 } onMouseLeave={()=>{
    setHoverCourseCard("")
 }
 }


>
  {item?.typeLabel?<div className="courseCardAllTypeLabel">{JSON.parse(item?.typeLabel)?.post_title}</div>:""}
  {item?.typeLabel?<div className="courseCardAllStatusLabel">{JSON.parse(item?.statusLabel)?.post_title}</div>:""}
  
{ hoverCourseCard==item?.ID?<CourseCard1MouseOverNormal deleteCourseFallback={(v)=>{deleteCourseFallback(v)}} setCurrentAppCourses={()=>{setCurrentAppCourses()}}  appItem={{}} item={item} sendBackPopUpItem={(item)=>{setPopUpItem(item)}} onMouseLeaveFire={()=>{  setHoverCourseCard("")}} />:""}
 
   <ImageFallFB  itemOuter={{}}
                  boxShadow={``}
                  src={placeholderImg}
                  border={``}
                  width={ 100
                  }
                  aspectRatio={
                    2/1.2
                  }
                  borderRadius={
                    {
                      value: 10,
                      resolution: "%",
                    }
                  }
                /> 
                
                 
                 <div className="courseCard1MiddleButtons">
                           <div className="courseCard1MiddleButtons">
             {item?.languageLabel? <div className="courseCardAllLanguageLabel">{JSON.parse(item?.languageLabel)?.post_title}</div>:""}
              {item?.difficultyLabel?<div className="courseCardAllDifficultyLabel">{JSON.parse(item?.difficultyLabel)?.post_title}</div>:""}
              
              </div>  </div>
                <div className="CourseAllItemTitle">{item?.productName}</div>
</div>
</>))}

</>)
}
export default CourseCardNormal;